import { usePage } from "@inertiajs/react";
import { usePushNotifications } from "@/hooks/use-push-notifications";
import type { SharedData } from "@/types";

export function PushNotificationPrompt() {
  const { auth } = usePage<SharedData>().props;
  usePushNotifications({ autoPrompt: Boolean(auth.user) });

  return null;
}
